var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _c(
    "v-row",
    {
      attrs: {
        "no-gutters": ""
      }
    },
    [
      _c(
        "v-col",
        {
          attrs: {
            cols: "12"
          }
        },
        [
          _c(
            "gg-card",
            [
              _c(
                "gg-card-header",
                [
                  _vm.model.selected_destination === "fwd"
                    ? _c("span", [_vm._v("Create Forward to Email Forwarder")])
                    : _c("span", [_vm._v("Create Discard Email Forwarder")]),
                  _c(
                    "v-menu",
                    {
                      attrs: {
                        "offset-y": ""
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "activator",
                          fn: function fn(_ref) {
                            var on = _ref.on,
                              attrs = _ref.attrs
                            return [
                              _c(
                                "v-btn",
                                _vm._g(
                                  {
                                    staticClass: "ml-2",
                                    attrs: {
                                      icon: "",
                                      small: "",
                                      color: "primary"
                                    }
                                  },
                                  on
                                ),
                                [_c("v-icon", [_vm._v("mdi-dots-horizontal")])],
                                1
                              )
                            ]
                          }
                        }
                      ])
                    },
                    [
                      _c(
                        "v-list",
                        [
                          _c(
                            "v-list-item",
                            {
                              on: {
                                click: function click($event) {
                                  _vm.model.selected_destination = "fwd"
                                }
                              }
                            },
                            [
                              _c("v-list-item-title", [
                                _vm._v("Forward to Email")
                              ])
                            ],
                            1
                          ),
                          _c(
                            "v-list-item",
                            {
                              on: {
                                click: function click($event) {
                                  _vm.model.selected_destination = "fail"
                                }
                              }
                            },
                            [
                              _c("v-list-item-title", [_vm._v("Discard Email")])
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "gg-card-text",
                [
                  _c(
                    "v-container",
                    {
                      attrs: {
                        fluid: ""
                      }
                    },
                    [
                      _c(
                        "v-row",
                        [
                          _c(
                            "v-col",
                            {
                              staticClass: "pb-0",
                              attrs: {
                                cols: "12",
                                md: "6"
                              }
                            },
                            [
                              _c("gg-text-field", {
                                directives: [
                                  {
                                    name: "validate",
                                    rawName: "v-validate",
                                    value: _vm.rules.address,
                                    expression: "rules.address"
                                  }
                                ],
                                staticClass: "forw",
                                attrs: {
                                  label: "Address to forward",
                                  placeholder: "For example: info",
                                  name: "address",
                                  outlined: "",
                                  "data-vv-as": "Address",
                                  "error-messages": _vm.errors.collect(
                                    "address"
                                  )
                                },
                                scopedSlots: _vm._u([
                                  {
                                    key: "append",
                                    fn: function fn() {
                                      return [
                                        _c(
                                          "div",
                                          {
                                            staticClass: "append-bg"
                                          },
                                          [
                                            _c("domain-select", {
                                              staticStyle: {
                                                "margin-top": "10px"
                                              },
                                              attrs: {
                                                "no-label": "",
                                                "hide-details": "",
                                                solo: "",
                                                flat: "",
                                                "prepend-inner-icon": "mdi-at"
                                              },
                                              model: {
                                                value: _vm.model.domain,
                                                callback: function callback(
                                                  $$v
                                                ) {
                                                  _vm.$set(
                                                    _vm.model,
                                                    "domain",
                                                    $$v
                                                  )
                                                },
                                                expression: "model.domain"
                                              }
                                            })
                                          ],
                                          1
                                        )
                                      ]
                                    },
                                    proxy: true
                                  }
                                ]),
                                model: {
                                  value: _vm.model.address,
                                  callback: function callback($$v) {
                                    _vm.$set(_vm.model, "address", $$v)
                                  },
                                  expression: "model.address"
                                }
                              })
                            ],
                            1
                          ),
                          !_vm.isBlackholeActive
                            ? _c(
                                "v-col",
                                {
                                  staticClass: "pb-0",
                                  attrs: {
                                    cols: "12",
                                    md: "6"
                                  }
                                },
                                [
                                  _vm.isFwdActive
                                    ? _c("gg-text-field", {
                                        directives: [
                                          {
                                            name: "validate",
                                            rawName: "v-validate",
                                            value: _vm.rules.forward,
                                            expression: "rules.forward"
                                          }
                                        ],
                                        key: "destination-input",
                                        attrs: {
                                          label: "Destination",
                                          placeholder:
                                            "Please enter your email",
                                          outlined: "",
                                          "data-vv-name": "forward",
                                          "data-vv-as": "Forward message",
                                          "error-messages": _vm.errors.collect(
                                            "forward"
                                          )
                                        },
                                        model: {
                                          value: _vm.model.type.forward,
                                          callback: function callback($$v) {
                                            _vm.$set(
                                              _vm.model.type,
                                              "forward",
                                              $$v
                                            )
                                          },
                                          expression: "model.type.forward"
                                        }
                                      })
                                    : _vm._e(),
                                  _vm.isFailActive
                                    ? _c("gg-text-field", {
                                        directives: [
                                          {
                                            name: "validate",
                                            rawName: "v-validate",
                                            value: _vm.rules.fail,
                                            expression: "rules.fail"
                                          }
                                        ],
                                        key: "fail-input",
                                        attrs: {
                                          label:
                                            "Failure message (seen by sender)",
                                          "data-vv-name": "fail",
                                          "data-vv-as": "Failure message",
                                          "error-messages": _vm.errors.collect(
                                            "fail"
                                          )
                                        },
                                        model: {
                                          value: _vm.model.type.fail,
                                          callback: function callback($$v) {
                                            _vm.$set(
                                              _vm.model.type,
                                              "fail",
                                              $$v
                                            )
                                          },
                                          expression: "model.type.fail"
                                        }
                                      })
                                    : _vm._e(),
                                  _vm.isSystemActive
                                    ? _c("gg-text-field", {
                                        directives: [
                                          {
                                            name: "validate",
                                            rawName: "v-validate",
                                            value: _vm.rules.system,
                                            expression: "rules.system"
                                          }
                                        ],
                                        key: "system-input",
                                        attrs: {
                                          label:
                                            "Failure message (seen by sender)",
                                          "data-vv-name": "system",
                                          "data-vv-as":
                                            "Forward to system account",
                                          "error-messages": _vm.errors.collect(
                                            "system"
                                          )
                                        },
                                        model: {
                                          value: _vm.model.type.system,
                                          callback: function callback($$v) {
                                            _vm.$set(
                                              _vm.model.type,
                                              "system",
                                              $$v
                                            )
                                          },
                                          expression: "model.type.system"
                                        }
                                      })
                                    : _vm._e(),
                                  _vm.isPipeActive
                                    ? _c("autocomplete-dir", {
                                        directives: [
                                          {
                                            name: "validate",
                                            rawName: "v-validate",
                                            value: _vm.rules.pipe,
                                            expression: "rules.pipe"
                                          }
                                        ],
                                        key: "dir-input",
                                        attrs: {
                                          "data-vv-name": "pipe",
                                          "data-vv-as": "Pipe to a program",
                                          "error-messages": _vm.errors.collect(
                                            "pipe"
                                          )
                                        },
                                        model: {
                                          value: _vm.model.type.pipe,
                                          callback: function callback($$v) {
                                            _vm.$set(
                                              _vm.model.type,
                                              "pipe",
                                              $$v
                                            )
                                          },
                                          expression: "model.type.pipe"
                                        }
                                      })
                                    : _vm._e()
                                ],
                                1
                              )
                            : _vm._e(),
                          _c(
                            "v-col",
                            {
                              attrs: {
                                cols: "12"
                              }
                            },
                            [
                              _c(
                                "gg-btn",
                                {
                                  attrs: {
                                    color: "primary",
                                    tile: "",
                                    loading: _vm.loading
                                  },
                                  on: {
                                    click: _vm.addNewForwarder
                                  }
                                },
                                [_vm._v(" Create ")]
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }